import { render, staticRenderFns } from "./dataManagetable.vue?vue&type=template&id=07df3ab9&scoped=true&"
import script from "./dataManagetable.vue?vue&type=script&lang=js&"
export * from "./dataManagetable.vue?vue&type=script&lang=js&"
import style0 from "./dataManagetable.vue?vue&type=style&index=0&id=07df3ab9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df3ab9",
  null
  
)

export default component.exports